import { PopoverMenuComponent } from 'commons/components';
import { PredefinedCommentsActivateDeactivateCommandComponent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/components/commands/predefined-comments-activate-deactivate-command.component';
import { PredefinedComment } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/predefined-comments.model';
import { useActivateDeactivatePredefinedComment } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-activate-deactivate-predefined-comment.hook';
import { useTranslation } from 'core/i18n';
import { PredefinedCommentEditCommandComponent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/components/commands/predefined-comment-edit-command.component';

export interface PredefinedCommentsActiveRowOptionsComponentProps {
    predefinedComment: PredefinedComment;
}

export const PredefinedCommentsActiveRowOptionsComponent = ({
    predefinedComment,
}: PredefinedCommentsActiveRowOptionsComponentProps) => {
    const { t } = useTranslation();
    const { showDeactivateModal } = useActivateDeactivatePredefinedComment();

    return [
        <PredefinedCommentEditCommandComponent
            key={`predefined-comment-edit-option-${predefinedComment.id}`}
            commentId={predefinedComment.id}
        />,
        <PopoverMenuComponent
            key={`row-options-active-predefined-comment-${predefinedComment.id}`}
            anchor={`predefined-comment-active-row-options-${predefinedComment.id}`}
        >
            <PredefinedCommentsActivateDeactivateCommandComponent
                onClick={() => showDeactivateModal([predefinedComment])}
                text={t('settings.devices.predefined-comments.list.actions.deactivate')}
                iconName="circle_remove"
            />
        </PopoverMenuComponent>,
    ];
};
